import Request from 'gd-request';

export default class ApiRecurrence {

    create(params={}) {
        return new Request(this, 'POST', 'recurrence/create', params);
    }

    get(recurrenceId) {
        return new Request(this, 'GET', 'recurrence/'+recurrenceId);
    }

    delete(recurrenceId) {
        return new Request(this, 'DELETE', 'recurrence/'+recurrenceId);
    }

    update(recurrenceId, payload) {
        return new Request(this, 'PUT', 'recurrence/'+recurrenceId, payload);
    }

    selectAll() {
        return new Request(this, 'GET', 'recurrence/all');
    }


    // get(params={}) {
    //     return new Request(this, 'GET', 'trash', params);
    // }
    //
    //
    // restore(deletedItemId) {
    //     return new Request(this, 'POST', 'trash/restore', {
    //         id: deletedItemId
    //     });
    // }



}
